export default {
    data: () => {
        return {
            
        }
    },
    methods: {
        getTranslateSpace(string) {
            if(string.indexOf("&nbsp") === -1)
                return(this.$t(string));
            
            const matches = string.match(/&nbsp;/);
            string = string.replace(/&nbsp;/g, '');
            return "&nbsp&nbsp&nbsp" + this.$t(string);
        },
        getTranslateParams (string) {
            const alias = this.getNormalizeAlias(string);
            if (!/\d/.test(string))
                return ['errors.' + alias];
            
            const numbers = string.match(/\b[\d]+\b/g);
            return ['errors.' + alias, numbers];
        },
        getNormalizeAlias(string) {
            let result = string.replace(/\d+(?:\.\d+)?/g, '')
                .replace(/ {1,}/g, ' ')
                .replace(/ /ig, '_')
                .replace(/\,/g, '')
                .replace(/\./g, '')
                .replace(/\@/g, '')
                .toLowerCase();

            if(result[result.length - 1] === "_")
                result = result.slice(0, -1);

            return result;
        }
    }
}
